<template>
    <button type="button" class="d-none" data-toggle="modal" data-target=".moveFileModals" id="moveFileBtn"> </button>
    <div class="modal fade bd-example-modal-xl moveFileModals" id="moveFileModalId" tabindex="-1" role="dialog" aria-hidden="true">
        <div class=" modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Move "{{$store.state.fileNameParam}}"</h5>
                    <button type="button" class="close" id="closeMoveFilePop" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group col-md-12">
                        <div class="card-transparent card-block card-stretch card-height mb-3">
                            <div class="d-flex justify-content-between">
                                <div class="select-dropdown input-prepend input-append">
                                    <nav aria-label="breadcrumb" v-if="breadcrumbItems.length > 0">
                                        <ol class="breadcrumb">
                                             <li 
                                                class="breadcrumb-item active" 
                                                v-if="breadcrumbItems.length > 0"
                                                @click="detailHomeFolder()"
                                                >
                                                <span class="cursor-pointer">Home</span>
                                            </li>
                                            <template v-for="(item, index) in breadcrumbItems" :key="index">
                                                <li 
                                                class="breadcrumb-item active" 
                                                v-if="item !== ''"
                                                @click="detailSubFolder(index)"
                                                >
                                                <span class="cursor-pointer">{{ item }}</span>
                                                </li>
                                            </template>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-12">
                            <ul class="list-group list-group-flush" v-if="$store.state.isSubFolder === 1">
                                <li 
                                    class="list-group-item d-flex align-items-center justify-content-between folder-item" 
                                    v-for="(item) in $store.state.folderList" 
                                    :key="'main-' + item._id"
                                >
                                    <!-- Left: Folder icon + name -->
                                    <div class="d-flex align-items-center">
                                    <div class="icon-small me-2">
                                        <FolderSvg />
                                    </div>
                                    <span class="folder-name">{{ item.name }}</span>
                                    </div>
                                    <div class="folder-actions d-flex align-items-center">
                                        <button class="btn btn-link btn-sm text-primary p-0 me-2">Move</button>
                                    </div>
                                    <div class="folder-actions d-flex align-items-center" @click="detailFolder(item.key, '', item.fullKey)">
                                        <i class="ri-arrow-right-wide-line cursor-pointer" ></i>
                                    </div>
                                </li>
                            </ul>
                            <ul class="list-group list-group-flush" v-if="$store.state.isSubFolder === 2">
                                <li 
                                    class="list-group-item d-flex align-items-center justify-content-between folder-item" 
                                    v-for="(item) in $store.state.folderSubList" 
                                    :key="'sub-' + item._id"
                                >
                                    <!-- Left: Folder icon + name -->
                                    <div class="d-flex align-items-center">
                                    <div class="icon-small me-2">
                                        <FolderSvg />
                                    </div>
                                    <span class="folder-name">{{ item.name }}</span>
                                    </div>
                                    <div class="folder-actions d-flex align-items-center">
                                        <button class="btn btn-link btn-sm text-primary p-0 me-2">Move</button>
                                    </div>
                                    <div class="folder-actions d-flex align-items-center" @click="detailFolder(item.key, folderPath, item.fullKey)">
                                        <i class="ri-arrow-right-wide-line cursor-pointer" ></i>
                                    </div>
                                </li>
                            </ul>
                    </div>
                </div>
                <div class="modal-footer">
                <!-- {{ item.fullKey }} -->
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-primary" v-on:click="MoveToFolder" v-if="formLoader === 1">Move</button>
                        <button type="button" class="btn btn-primary" v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {
        startLoader,
        finishLoader
} from '../../utils/helper.js'
import 
    { post } 
from '../../utils/api.js'
import FolderSvg from '@/components/Widgets/Icon/Folder.vue'
export default {
    name: 'MoveFileData',
    data() {
        return {
            folderPath: '',
            formLoader: 1,
            fullLatestKey: 1,
        }
    },
    components: {
            FolderSvg
        },
        computed: {
            breadcrumbItems() {
                return this.folderPath.split('/').filter(item => item !== '');
            }
    },  
    methods: {
        startLoader,
        finishLoader,
        async loadFolderList(isMain) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
            let _post = {}
            if (isMain === 1) {
                _post = {
                    // limit: 8,
                }
            }else{
                _post = {
                    folderName: this.folderPath,
                }
            }
            this.startLoader();
            const resp = await post('files/list-folders', _post)
            if (resp.status == 200 && resp.data.status == 'success') {
                if (isMain === 1) {
                    this.$store.state.folderList = resp.data.data.folders;
                }else{
                    this.$store.state.folderSubList = resp.data.data.folders;
                }
            } else {
                this.errorMessage = resp.data.message;
            }
            this.finishLoader();
        },
        async openMoveFile(id, name, fullKey) {
            this.$store.state.fileNameParam = name;
            this.$store.state.fileNameIdParam = id;
            this.$store.state.fullOldKey = fullKey;
            this.$store.state.isSubFolder = 1;
            this.folderPath = '';
            await this.loadFolderList(1);
            document.getElementById('moveFileBtn').click();
        },
        async detailHomeFolder() {
            this.folderPath = '';
            this.$store.state.isSubFolder = 1;
            await this.loadFolderList(1);
        },
        async detailFolder(key, folderPath, fullKey) {
            this.fullLatestKey = fullKey;
            if(folderPath == '') {
                this.folderPath = key;
            } else {
                this.folderPath = folderPath+'/'+key;
            }
            this.$store.state.isSubFolder = 2;
            await this.loadFolderList(2);
        },
        detailSubFolder(index) {
            const newPath = this.breadcrumbItems.slice(0, index + 1).join('/');
            this.folderPath = newPath; // or emit it / update store etc.
            console.log('Updated path:', newPath);
            this.detailFolder(newPath, '')
            
            // Optional: trigger loading or routing logic here
            // this.loadFolderContent(newPath)
        },
        async MoveToFolder() {
            let _post = {}
            _post = {
                oldPath: this.$store.state.fullOldKey,
                newPath: this.fullLatestKey+''+this.$store.state.fileNameParam,
            }
            this.startLoader();
            const resp = await post('files/move-file', _post)
            if (resp.status == 200 && resp.data.status == 'success') {
                this.$store.state.home.reLoadFoldercomponent = Math.random();
                this.$store.state.home.reLoadFilecomponent = Math.random();
                document.getElementById('closeMoveFilePop').click();
            } else {
                this.errorMessage = resp.data.message;
            }
            this.finishLoader();
        },
    },
}
</script>
